import styleInject from '../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = "/*\n *\n * Copyright (c) Vaisala Oyj. All rights reserved.\n *\n */\n/*\n *\n * Copyright (c) Vaisala Oyj. All rights reserved.\n * \n */\n.vai-form-error {\n  color: #df1616;\n}\n.vai-form-error--message {\n  margin-right: 4px;\n}\n\n.vai-theme-dark .vai-form-error {\n  color: rgba(223, 22, 22, 0.75);\n}";
styleInject(css_248z);

export { css_248z as default };
